import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import ButtonGroup from "@material-ui/core/ButtonGroup";

const useStyles = makeStyles(theme => ({
	root: {
		width: "100%",
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper
	}
}));

export default function ListDividers() {
	const classes = useStyles();

	return (
		<List component="nav" className={classes.root} aria-label="mailbox folders">
			<ListItem button>
				<ListItemText primary="Agenda 1" />
				<div>
					<button
						className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored bttn"
						data-field="1.pdf"
					>
						View
					</button>
				</div>
			</ListItem>
			<Divider />
			<ListItem button divider>
				<ListItemText primary="Agenda 2" />
				<button
					className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored bttn"
					data-field="3.pdf"
				>
					View
				</button>
			</ListItem>
		</List>
	);
}
